import React from "react";
import MUICollapse from "@mui/material/Collapse";
import usePrefersReducedMotion from "../../hooks/usePrefersReducedMotion";
const Collapse = ({ transitionIn, className, children, }) => {
    const prefersReducedMotion = usePrefersReducedMotion();
    return (React.createElement(MUICollapse, { in: transitionIn, timeout: prefersReducedMotion ? 0 : "auto", unmountOnExit: true, classes: { wrapperInner: className } }, children));
};
export default Collapse;
//# sourceMappingURL=Collapse.js.map